export const currencyConversion = async (fromCurrency: string, amount: number, toCurrency: string): Promise<number> => {
    const apiUrl = `https://api.frankfurter.app/latest?amount=${amount}&from=${fromCurrency}&to=${toCurrency}`;
    try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        return data.rates[toCurrency];
    } catch (error) {
        console.error("Currency conversion failed:", error);
        return 0;
    }
};

export const convertPrice_OnlyUSD_WithTax = async (price: number, regionId: number): Promise<string> => {
    if (regionId === 1) {
        return `₹${price}`;
    } else {
        const taxedPrice = price * 1.18;
        const converted = await currencyConversion("INR", taxedPrice, "USD");
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        }).format(converted);
    }
};

// In CurrencyConverter.ts
export function convertDateFromTFormat(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });
}
